import React from 'react';
interface Props {
  className?: string;
  onClick?: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
  type?: 'primary' | 'default' | 'danger' | 'warning' | 'gray' | 'origin-red' | 'green';
  size?: 'xs' | 'sm' | 'md' | 'lg';
  long?: boolean;
  shape?: 'circle' | 'round';
  outline?: boolean;
  style?: React.CSSProperties;
}
export default function Button({ className, style, onClick, children, disabled, type, size, shape, outline, long }: Props) {
  return (
    <div
      className={` button ${type ?? 'default'} ${size ?? 'sm'} ${shape ?? 'round'} ${
        outline ? 'outline' : ''
        } ${long ? 'long' : ''} ${disabled ? 'disabled' : ''} ${className}`}
      style={style}
      onClick={!disabled && onClick ? onClick : undefined}
    >
      {children}
    </div>
  );
}
